import { ApiService } from "./AbstractApiService";
import { IEmail, IEmailConfig } from "@/interfaces/iEmail";
import { IPageModel } from "@/interfaces/iPageModel";
// import API from "./handlers/base.service";
import qs from "qs";
export class EmailAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: EmailAPI | null;
  constructor() {
    super("notification");
  }
  public async getEmailsList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IEmail>> {
    return this.get("emails", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async getEmailConfigList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IEmailConfig>> {
    return this.get("emailConfigs", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async deleteEmailConfigs(
    ids?: Record<string, string | number>
  ): Promise<IPageModel<IEmailConfig>> {
    return this.service
      .delete("notification/emailConfigs", { data: ids })
      .then((response) => response.data);
  }

  public async addEmailConfig(
    payload?: IEmailConfig,
    edit?: boolean
  ): Promise<IPageModel<IEmailConfig>> {
    if (edit) {
      return this.put(`emailConfigs/${payload?.webId}`, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("emailConfigs", payload).then(
        (response) => response.data
      );
    }
  }
  public async getEmailConfigs(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IEmailConfig>> {
    return this.get("eventConfigs", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async addEventConfig(
    payload?: IEmailConfig,
    edit?: boolean
  ): Promise<IPageModel<IEmailConfig>> {
    if (edit) {
      return this.put(`eventConfigs/${payload?.webId}`, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("eventConfigs", payload).then(
        (response) => response.data
      );
    }
  }
  // deleteemailConfigs
  public async deleteEventConfigs(
    ids?: Record<string, string | number>
  ): Promise<IPageModel<IEmailConfig>> {
    return this.service
      .delete("notification/eventConfigs", { data: ids })
      .then((response) => response.data);
  }
}
